module.exports = __webpack_public_path__ + "img/shipin.4154cdd4.png";